var items = {
  "block.minecraft.air": "空气",
  "block.minecraft.stone": "石头",
  "block.minecraft.granite": "花岗岩",
  "block.minecraft.polished_granite": "磨制花岗岩",
  "block.minecraft.diorite": "闪长岩",
  "block.minecraft.polished_diorite": "磨制闪长岩",
  "block.minecraft.andesite": "安山岩",
  "block.minecraft.polished_andesite": "磨制安山岩",
  "block.minecraft.grass_block": "草方块",
  "block.minecraft.dirt": "泥土",
  "block.minecraft.coarse_dirt": "砂土",
  "block.minecraft.podzol": "灰化土",
  "block.minecraft.crimson_nylium": "绯红菌岩",
  "block.minecraft.warped_nylium": "诡异菌岩",
  "block.minecraft.cobblestone": "圆石",
  "block.minecraft.oak_planks": "橡木木板",
  "block.minecraft.spruce_planks": "云杉木板",
  "block.minecraft.birch_planks": "白桦木板",
  "block.minecraft.jungle_planks": "丛林木板",
  "block.minecraft.acacia_planks": "金合欢木板",
  "block.minecraft.dark_oak_planks": "深色橡木木板",
  "block.minecraft.crimson_planks": "绯红木板",
  "block.minecraft.warped_planks": "诡异木板",
  "block.minecraft.oak_sapling": "橡树树苗",
  "block.minecraft.spruce_sapling": "云杉树苗",
  "block.minecraft.birch_sapling": "白桦树苗",
  "block.minecraft.jungle_sapling": "丛林树苗",
  "block.minecraft.acacia_sapling": "金合欢树苗",
  "block.minecraft.dark_oak_sapling": "深色橡树树苗",
  "block.minecraft.bedrock": "基岩",
  "block.minecraft.sand": "沙子",
  "block.minecraft.red_sand": "红沙",
  "block.minecraft.gravel": "沙砾",
  "block.minecraft.gold_ore": "金矿石",
  "block.minecraft.iron_ore": "铁矿石",
  "block.minecraft.coal_ore": "煤矿石",
  "block.minecraft.nether_gold_ore": "下界金矿石",
  "block.minecraft.oak_log": "橡木原木",
  "block.minecraft.spruce_log": "云杉原木",
  "block.minecraft.birch_log": "白桦原木",
  "block.minecraft.jungle_log": "丛林原木",
  "block.minecraft.acacia_log": "金合欢原木",
  "block.minecraft.dark_oak_log": "深色橡木原木",
  "block.minecraft.crimson_stem": "绯红菌柄",
  "block.minecraft.warped_stem": "诡异菌柄",
  "block.minecraft.stripped_oak_log": "去皮橡木原木",
  "block.minecraft.stripped_spruce_log": "去皮云杉原木",
  "block.minecraft.stripped_birch_log": "去皮白桦原木",
  "block.minecraft.stripped_jungle_log": "去皮丛林原木",
  "block.minecraft.stripped_acacia_log": "去皮金合欢原木",
  "block.minecraft.stripped_dark_oak_log": "去皮深色橡木原木",
  "block.minecraft.stripped_crimson_stem": "去皮绯红菌柄",
  "block.minecraft.stripped_warped_stem": "去皮诡异菌柄",
  "block.minecraft.stripped_oak_wood": "去皮橡木",
  "block.minecraft.stripped_spruce_wood": "去皮云杉木",
  "block.minecraft.stripped_birch_wood": "去皮白桦木",
  "block.minecraft.stripped_jungle_wood": "去皮丛林木",
  "block.minecraft.stripped_acacia_wood": "去皮金合欢木",
  "block.minecraft.stripped_dark_oak_wood": "去皮深色橡木",
  "block.minecraft.stripped_crimson_hyphae": "去皮绯红菌核",
  "block.minecraft.stripped_warped_hyphae": "去皮诡异菌核",
  "block.minecraft.oak_wood": "橡木",
  "block.minecraft.spruce_wood": "云杉木",
  "block.minecraft.birch_wood": "白桦木",
  "block.minecraft.jungle_wood": "丛林木",
  "block.minecraft.acacia_wood": "金合欢木",
  "block.minecraft.dark_oak_wood": "深色橡木",
  "block.minecraft.crimson_hyphae": "绯红菌核",
  "block.minecraft.warped_hyphae": "诡异菌核",
  "block.minecraft.oak_leaves": "橡树树叶",
  "block.minecraft.spruce_leaves": "云杉树叶",
  "block.minecraft.birch_leaves": "白桦树叶",
  "block.minecraft.jungle_leaves": "丛林树叶",
  "block.minecraft.acacia_leaves": "金合欢树叶",
  "block.minecraft.dark_oak_leaves": "深色橡树树叶",
  "block.minecraft.sponge": "海绵",
  "block.minecraft.wet_sponge": "湿海绵",
  "block.minecraft.glass": "玻璃",
  "block.minecraft.lapis_ore": "青金石矿石",
  "block.minecraft.lapis_block": "青金石块",
  "block.minecraft.dispenser": "发射器",
  "block.minecraft.sandstone": "砂岩",
  "block.minecraft.chiseled_sandstone": "錾制砂岩",
  "block.minecraft.cut_sandstone": "切制砂岩",
  "block.minecraft.note_block": "音符盒",
  "block.minecraft.powered_rail": "动力铁轨",
  "block.minecraft.detector_rail": "探测铁轨",
  "block.minecraft.sticky_piston": "黏性活塞",
  "block.minecraft.cobweb": "蜘蛛网",
  "block.minecraft.grass": "草",
  "block.minecraft.fern": "蕨",
  "block.minecraft.dead_bush": "枯萎的灌木",
  "block.minecraft.seagrass": "海草",
  "block.minecraft.sea_pickle": "海泡菜",
  "block.minecraft.piston": "活塞",
  "block.minecraft.white_wool": "白色羊毛",
  "block.minecraft.orange_wool": "橙色羊毛",
  "block.minecraft.magenta_wool": "品红色羊毛",
  "block.minecraft.light_blue_wool": "淡蓝色羊毛",
  "block.minecraft.yellow_wool": "黄色羊毛",
  "block.minecraft.lime_wool": "黄绿色羊毛",
  "block.minecraft.pink_wool": "粉红色羊毛",
  "block.minecraft.gray_wool": "灰色羊毛",
  "block.minecraft.light_gray_wool": "淡灰色羊毛",
  "block.minecraft.cyan_wool": "青色羊毛",
  "block.minecraft.purple_wool": "紫色羊毛",
  "block.minecraft.blue_wool": "蓝色羊毛",
  "block.minecraft.brown_wool": "棕色羊毛",
  "block.minecraft.green_wool": "绿色羊毛",
  "block.minecraft.red_wool": "红色羊毛",
  "block.minecraft.black_wool": "黑色羊毛",
  "block.minecraft.dandelion": "蒲公英",
  "block.minecraft.poppy": "虞美人",
  "block.minecraft.blue_orchid": "兰花",
  "block.minecraft.allium": "绒球葱",
  "block.minecraft.azure_bluet": "蓝花美耳草",
  "block.minecraft.red_tulip": "红色郁金香",
  "block.minecraft.orange_tulip": "橙色郁金香",
  "block.minecraft.white_tulip": "白色郁金香",
  "block.minecraft.pink_tulip": "粉红色郁金香",
  "block.minecraft.oxeye_daisy": "滨菊",
  "block.minecraft.cornflower": "矢车菊",
  "block.minecraft.lily_of_the_valley": "铃兰",
  "block.minecraft.wither_rose": "凋零玫瑰",
  "block.minecraft.brown_mushroom": "棕色蘑菇",
  "block.minecraft.red_mushroom": "红色蘑菇",
  "block.minecraft.crimson_fungus": "绯红菌",
  "block.minecraft.warped_fungus": "诡异菌",
  "block.minecraft.crimson_roots": "绯红菌索",
  "block.minecraft.warped_roots": "诡异菌索",
  "block.minecraft.nether_sprouts": "下界苗",
  "block.minecraft.weeping_vines": "垂泪藤",
  "block.minecraft.twisting_vines": "缠怨藤",
  "block.minecraft.sugar_cane": "甘蔗",
  "block.minecraft.kelp": "海带",
  "block.minecraft.bamboo": "竹子",
  "block.minecraft.gold_block": "金块",
  "block.minecraft.iron_block": "铁块",
  "block.minecraft.oak_slab": "橡木台阶",
  "block.minecraft.spruce_slab": "云杉木台阶",
  "block.minecraft.birch_slab": "白桦木台阶",
  "block.minecraft.jungle_slab": "丛林木台阶",
  "block.minecraft.acacia_slab": "金合欢木台阶",
  "block.minecraft.dark_oak_slab": "深色橡木台阶",
  "block.minecraft.crimson_slab": "绯红木台阶",
  "block.minecraft.warped_slab": "诡异木台阶",
  "block.minecraft.stone_slab": "石头台阶",
  "block.minecraft.smooth_stone_slab": "平滑石头台阶",
  "block.minecraft.sandstone_slab": "砂岩台阶",
  "block.minecraft.cut_sandstone_slab": "切制砂岩台阶",
  "block.minecraft.petrified_oak_slab": "石化橡木台阶",
  "block.minecraft.cobblestone_slab": "圆石台阶",
  "block.minecraft.brick_slab": "砖台阶",
  "block.minecraft.stone_brick_slab": "石砖台阶",
  "block.minecraft.nether_brick_slab": "下界砖台阶",
  "block.minecraft.quartz_slab": "石英台阶",
  "block.minecraft.red_sandstone_slab": "红砂岩台阶",
  "block.minecraft.cut_red_sandstone_slab": "切制红砂岩台阶",
  "block.minecraft.purpur_slab": "紫珀台阶",
  "block.minecraft.prismarine_slab": "海晶石台阶",
  "block.minecraft.prismarine_brick_slab": "海晶石砖台阶",
  "block.minecraft.dark_prismarine_slab": "暗海晶石台阶",
  "block.minecraft.smooth_quartz": "平滑石英块",
  "block.minecraft.smooth_red_sandstone": "平滑红砂岩",
  "block.minecraft.smooth_sandstone": "平滑砂岩",
  "block.minecraft.smooth_stone": "平滑石头",
  "block.minecraft.bricks": "砖块",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "书架",
  "block.minecraft.mossy_cobblestone": "苔石",
  "block.minecraft.obsidian": "黑曜石",
  "block.minecraft.torch": "火把",
  "block.minecraft.end_rod": "末地烛",
  "block.minecraft.chorus_plant": "紫颂植株",
  "block.minecraft.chorus_flower": "紫颂花",
  "block.minecraft.purpur_block": "紫珀块",
  "block.minecraft.purpur_pillar": "紫珀柱",
  "block.minecraft.purpur_stairs": "紫珀楼梯",
  "block.minecraft.spawner": "刷怪笼",
  "block.minecraft.oak_stairs": "橡木楼梯",
  "block.minecraft.chest": "箱子",
  "block.minecraft.diamond_ore": "钻石矿石",
  "block.minecraft.diamond_block": "钻石块",
  "block.minecraft.crafting_table": "工作台",
  "block.minecraft.farmland": "耕地",
  "block.minecraft.furnace": "熔炉",
  "block.minecraft.ladder": "梯子",
  "block.minecraft.rail": "铁轨",
  "block.minecraft.cobblestone_stairs": "圆石楼梯",
  "block.minecraft.lever": "拉杆",
  "block.minecraft.stone_pressure_plate": "石头压力板",
  "block.minecraft.oak_pressure_plate": "橡木压力板",
  "block.minecraft.spruce_pressure_plate": "云杉木压力板",
  "block.minecraft.birch_pressure_plate": "白桦木压力板",
  "block.minecraft.jungle_pressure_plate": "丛林木压力板",
  "block.minecraft.acacia_pressure_plate": "金合欢木压力板",
  "block.minecraft.dark_oak_pressure_plate": "深色橡木压力板",
  "block.minecraft.crimson_pressure_plate": "绯红木压力板",
  "block.minecraft.warped_pressure_plate": "诡异木压力板",
  "block.minecraft.polished_blackstone_pressure_plate": "磨制黑石压力板",
  "block.minecraft.redstone_ore": "红石矿石",
  "block.minecraft.redstone_torch": "红石火把",
  "block.minecraft.snow": "雪",
  "block.minecraft.ice": "冰",
  "block.minecraft.snow_block": "雪块",
  "block.minecraft.cactus": "仙人掌",
  "block.minecraft.clay": "黏土块",
  "block.minecraft.jukebox": "唱片机",
  "block.minecraft.oak_fence": "橡木栅栏",
  "block.minecraft.spruce_fence": "云杉木栅栏",
  "block.minecraft.birch_fence": "白桦木栅栏",
  "block.minecraft.jungle_fence": "丛林木栅栏",
  "block.minecraft.acacia_fence": "金合欢木栅栏",
  "block.minecraft.dark_oak_fence": "深色橡木栅栏",
  "block.minecraft.crimson_fence": "绯红木栅栏",
  "block.minecraft.warped_fence": "诡异木栅栏",
  "block.minecraft.pumpkin": "南瓜",
  "block.minecraft.carved_pumpkin": "雕刻过的南瓜",
  "block.minecraft.netherrack": "下界岩",
  "block.minecraft.soul_sand": "灵魂沙",
  "block.minecraft.soul_soil": "灵魂土",
  "block.minecraft.basalt": "玄武岩",
  "block.minecraft.polished_basalt": "磨制玄武岩",
  "block.minecraft.soul_torch": "灵魂火把",
  "block.minecraft.glowstone": "荧石",
  "block.minecraft.jack_o_lantern": "南瓜灯",
  "block.minecraft.oak_trapdoor": "橡木活板门",
  "block.minecraft.spruce_trapdoor": "云杉木活板门",
  "block.minecraft.birch_trapdoor": "白桦木活板门",
  "block.minecraft.jungle_trapdoor": "丛林木活板门",
  "block.minecraft.acacia_trapdoor": "金合欢木活板门",
  "block.minecraft.dark_oak_trapdoor": "深色橡木活板门",
  "block.minecraft.crimson_trapdoor": "绯红木活板门",
  "block.minecraft.warped_trapdoor": "诡异木活板门",
  "block.minecraft.infested_stone": "被虫蚀的石头",
  "block.minecraft.infested_cobblestone": "被虫蚀的圆石",
  "block.minecraft.infested_stone_bricks": "被虫蚀的石砖",
  "block.minecraft.infested_mossy_stone_bricks": "被虫蚀的苔石砖",
  "block.minecraft.infested_cracked_stone_bricks": "被虫蚀的裂纹石砖",
  "block.minecraft.infested_chiseled_stone_bricks": "被虫蚀的錾制石砖",
  "block.minecraft.stone_bricks": "石砖",
  "block.minecraft.mossy_stone_bricks": "苔石砖",
  "block.minecraft.cracked_stone_bricks": "裂纹石砖",
  "block.minecraft.chiseled_stone_bricks": "錾制石砖",
  "block.minecraft.brown_mushroom_block": "棕色蘑菇方块",
  "block.minecraft.red_mushroom_block": "红色蘑菇方块",
  "block.minecraft.mushroom_stem": "蘑菇柄",
  "block.minecraft.iron_bars": "铁栏杆",
  "block.minecraft.chain": "锁链",
  "block.minecraft.glass_pane": "玻璃板",
  "block.minecraft.melon": "西瓜",
  "block.minecraft.vine": "藤蔓",
  "block.minecraft.oak_fence_gate": "橡木栅栏门",
  "block.minecraft.spruce_fence_gate": "云杉木栅栏门",
  "block.minecraft.birch_fence_gate": "白桦木栅栏门",
  "block.minecraft.jungle_fence_gate": "丛林木栅栏门",
  "block.minecraft.acacia_fence_gate": "金合欢木栅栏门",
  "block.minecraft.dark_oak_fence_gate": "深色橡木栅栏门",
  "block.minecraft.crimson_fence_gate": "绯红木栅栏门",
  "block.minecraft.warped_fence_gate": "诡异木栅栏门",
  "block.minecraft.brick_stairs": "砖楼梯",
  "block.minecraft.stone_brick_stairs": "石砖楼梯",
  "block.minecraft.mycelium": "菌丝",
  "block.minecraft.lily_pad": "睡莲",
  "block.minecraft.nether_bricks": "下界砖块",
  "block.minecraft.cracked_nether_bricks": "裂纹下界砖块",
  "block.minecraft.chiseled_nether_bricks": "錾制下界砖块",
  "block.minecraft.nether_brick_fence": "下界砖栅栏",
  "block.minecraft.nether_brick_stairs": "下界砖楼梯",
  "block.minecraft.enchanting_table": "附魔台",
  "block.minecraft.end_portal_frame": "末地传送门框架",
  "block.minecraft.end_stone": "末地石",
  "block.minecraft.end_stone_bricks": "末地石砖",
  "block.minecraft.dragon_egg": "龙蛋",
  "block.minecraft.redstone_lamp": "红石灯",
  "block.minecraft.sandstone_stairs": "砂岩楼梯",
  "block.minecraft.emerald_ore": "绿宝石矿石",
  "block.minecraft.ender_chest": "末影箱",
  "block.minecraft.tripwire_hook": "绊线钩",
  "block.minecraft.emerald_block": "绿宝石块",
  "block.minecraft.spruce_stairs": "云杉木楼梯",
  "block.minecraft.birch_stairs": "白桦木楼梯",
  "block.minecraft.jungle_stairs": "丛林木楼梯",
  "block.minecraft.crimson_stairs": "绯红木楼梯",
  "block.minecraft.warped_stairs": "诡异木楼梯",
  "block.minecraft.command_block": "命令方块",
  "block.minecraft.beacon": "信标",
  "block.minecraft.cobblestone_wall": "圆石墙",
  "block.minecraft.mossy_cobblestone_wall": "苔石墙",
  "block.minecraft.brick_wall": "砖块墙",
  "block.minecraft.prismarine_wall": "海晶石墙",
  "block.minecraft.red_sandstone_wall": "红砂岩墙",
  "block.minecraft.mossy_stone_brick_wall": "苔石砖墙",
  "block.minecraft.granite_wall": "花岗岩墙",
  "block.minecraft.stone_brick_wall": "石砖墙",
  "block.minecraft.nether_brick_wall": "下界砖墙",
  "block.minecraft.andesite_wall": "安山岩墙",
  "block.minecraft.red_nether_brick_wall": "红色下界砖墙",
  "block.minecraft.sandstone_wall": "砂岩墙",
  "block.minecraft.end_stone_brick_wall": "末地石砖墙",
  "block.minecraft.diorite_wall": "闪长岩墙",
  "block.minecraft.blackstone_wall": "黑石墙",
  "block.minecraft.polished_blackstone_wall": "磨制黑石墙",
  "block.minecraft.polished_blackstone_brick_wall": "磨制黑石砖墙",
  "block.minecraft.stone_button": "石头按钮",
  "block.minecraft.oak_button": "橡木按钮",
  "block.minecraft.spruce_button": "云杉木按钮",
  "block.minecraft.birch_button": "白桦木按钮",
  "block.minecraft.jungle_button": "丛林木按钮",
  "block.minecraft.acacia_button": "金合欢木按钮",
  "block.minecraft.dark_oak_button": "深色橡木按钮",
  "block.minecraft.crimson_button": "绯红木按钮",
  "block.minecraft.warped_button": "诡异木按钮",
  "block.minecraft.polished_blackstone_button": "磨制黑石按钮",
  "block.minecraft.anvil": "铁砧",
  "block.minecraft.chipped_anvil": "开裂的铁砧",
  "block.minecraft.damaged_anvil": "损坏的铁砧",
  "block.minecraft.trapped_chest": "陷阱箱",
  "block.minecraft.light_weighted_pressure_plate": "轻质测重压力板",
  "block.minecraft.heavy_weighted_pressure_plate": "重质测重压力板",
  "block.minecraft.daylight_detector": "阳光探测器",
  "block.minecraft.redstone_block": "红石块",
  "block.minecraft.nether_quartz_ore": "下界石英矿石",
  "block.minecraft.hopper": "漏斗",
  "block.minecraft.chiseled_quartz_block": "錾制石英块",
  "block.minecraft.quartz_block": "石英块",
  "block.minecraft.quartz_bricks": "石英砖",
  "block.minecraft.quartz_pillar": "石英柱",
  "block.minecraft.quartz_stairs": "石英楼梯",
  "block.minecraft.activator_rail": "激活铁轨",
  "block.minecraft.dropper": "投掷器",
  "block.minecraft.white_terracotta": "白色陶瓦",
  "block.minecraft.orange_terracotta": "橙色陶瓦",
  "block.minecraft.magenta_terracotta": "品红色陶瓦",
  "block.minecraft.light_blue_terracotta": "淡蓝色陶瓦",
  "block.minecraft.yellow_terracotta": "黄色陶瓦",
  "block.minecraft.lime_terracotta": "黄绿色陶瓦",
  "block.minecraft.pink_terracotta": "粉红色陶瓦",
  "block.minecraft.gray_terracotta": "灰色陶瓦",
  "block.minecraft.light_gray_terracotta": "淡灰色陶瓦",
  "block.minecraft.cyan_terracotta": "青色陶瓦",
  "block.minecraft.purple_terracotta": "紫色陶瓦",
  "block.minecraft.blue_terracotta": "蓝色陶瓦",
  "block.minecraft.brown_terracotta": "棕色陶瓦",
  "block.minecraft.green_terracotta": "绿色陶瓦",
  "block.minecraft.red_terracotta": "红色陶瓦",
  "block.minecraft.black_terracotta": "黑色陶瓦",
  "block.minecraft.barrier": "屏障",
  "block.minecraft.iron_trapdoor": "铁活板门",
  "block.minecraft.hay_block": "干草块",
  "block.minecraft.white_carpet": "白色地毯",
  "block.minecraft.orange_carpet": "橙色地毯",
  "block.minecraft.magenta_carpet": "品红色地毯",
  "block.minecraft.light_blue_carpet": "淡蓝色地毯",
  "block.minecraft.yellow_carpet": "黄色地毯",
  "block.minecraft.lime_carpet": "黄绿色地毯",
  "block.minecraft.pink_carpet": "粉红色地毯",
  "block.minecraft.gray_carpet": "灰色地毯",
  "block.minecraft.light_gray_carpet": "淡灰色地毯",
  "block.minecraft.cyan_carpet": "青色地毯",
  "block.minecraft.purple_carpet": "紫色地毯",
  "block.minecraft.blue_carpet": "蓝色地毯",
  "block.minecraft.brown_carpet": "棕色地毯",
  "block.minecraft.green_carpet": "绿色地毯",
  "block.minecraft.red_carpet": "红色地毯",
  "block.minecraft.black_carpet": "黑色地毯",
  "block.minecraft.terracotta": "陶瓦",
  "block.minecraft.coal_block": "煤炭块",
  "block.minecraft.packed_ice": "浮冰",
  "block.minecraft.acacia_stairs": "金合欢木楼梯",
  "block.minecraft.dark_oak_stairs": "深色橡木楼梯",
  "block.minecraft.slime_block": "黏液块",
  "block.minecraft.grass_path": "草径",
  "block.minecraft.sunflower": "向日葵",
  "block.minecraft.lilac": "丁香",
  "block.minecraft.rose_bush": "玫瑰丛",
  "block.minecraft.peony": "牡丹",
  "block.minecraft.tall_grass": "高草丛",
  "block.minecraft.large_fern": "大型蕨",
  "block.minecraft.white_stained_glass": "白色染色玻璃",
  "block.minecraft.orange_stained_glass": "橙色染色玻璃",
  "block.minecraft.magenta_stained_glass": "品红色染色玻璃",
  "block.minecraft.light_blue_stained_glass": "淡蓝色染色玻璃",
  "block.minecraft.yellow_stained_glass": "黄色染色玻璃",
  "block.minecraft.lime_stained_glass": "黄绿色染色玻璃",
  "block.minecraft.pink_stained_glass": "粉红色染色玻璃",
  "block.minecraft.gray_stained_glass": "灰色染色玻璃",
  "block.minecraft.light_gray_stained_glass": "淡灰色染色玻璃",
  "block.minecraft.cyan_stained_glass": "青色染色玻璃",
  "block.minecraft.purple_stained_glass": "紫色染色玻璃",
  "block.minecraft.blue_stained_glass": "蓝色染色玻璃",
  "block.minecraft.brown_stained_glass": "棕色染色玻璃",
  "block.minecraft.green_stained_glass": "绿色染色玻璃",
  "block.minecraft.red_stained_glass": "红色染色玻璃",
  "block.minecraft.black_stained_glass": "黑色染色玻璃",
  "block.minecraft.white_stained_glass_pane": "白色染色玻璃板",
  "block.minecraft.orange_stained_glass_pane": "橙色染色玻璃板",
  "block.minecraft.magenta_stained_glass_pane": "品红色染色玻璃板",
  "block.minecraft.light_blue_stained_glass_pane": "淡蓝色染色玻璃板",
  "block.minecraft.yellow_stained_glass_pane": "黄色染色玻璃板",
  "block.minecraft.lime_stained_glass_pane": "黄绿色染色玻璃板",
  "block.minecraft.pink_stained_glass_pane": "粉红色染色玻璃板",
  "block.minecraft.gray_stained_glass_pane": "灰色染色玻璃板",
  "block.minecraft.light_gray_stained_glass_pane": "淡灰色染色玻璃板",
  "block.minecraft.cyan_stained_glass_pane": "青色染色玻璃板",
  "block.minecraft.purple_stained_glass_pane": "紫色染色玻璃板",
  "block.minecraft.blue_stained_glass_pane": "蓝色染色玻璃板",
  "block.minecraft.brown_stained_glass_pane": "棕色染色玻璃板",
  "block.minecraft.green_stained_glass_pane": "绿色染色玻璃板",
  "block.minecraft.red_stained_glass_pane": "红色染色玻璃板",
  "block.minecraft.black_stained_glass_pane": "黑色染色玻璃板",
  "block.minecraft.prismarine": "海晶石",
  "block.minecraft.prismarine_bricks": "海晶石砖",
  "block.minecraft.dark_prismarine": "暗海晶石",
  "block.minecraft.prismarine_stairs": "海晶石楼梯",
  "block.minecraft.prismarine_brick_stairs": "海晶石砖楼梯",
  "block.minecraft.dark_prismarine_stairs": "暗海晶石楼梯",
  "block.minecraft.sea_lantern": "海晶灯",
  "block.minecraft.red_sandstone": "红砂岩",
  "block.minecraft.chiseled_red_sandstone": "錾制红砂岩",
  "block.minecraft.cut_red_sandstone": "切制红砂岩",
  "block.minecraft.red_sandstone_stairs": "红砂岩楼梯",
  "block.minecraft.repeating_command_block": "循环型命令方块",
  "block.minecraft.chain_command_block": "连锁型命令方块",
  "block.minecraft.magma_block": "岩浆块",
  "block.minecraft.nether_wart_block": "下界疣块",
  "block.minecraft.warped_wart_block": "诡异疣块",
  "block.minecraft.red_nether_bricks": "红色下界砖块",
  "block.minecraft.bone_block": "骨块",
  "block.minecraft.structure_void": "结构空位",
  "block.minecraft.observer": "侦测器",
  "block.minecraft.shulker_box": "潜影盒",
  "block.minecraft.white_shulker_box": "白色潜影盒",
  "block.minecraft.orange_shulker_box": "橙色潜影盒",
  "block.minecraft.magenta_shulker_box": "品红色潜影盒",
  "block.minecraft.light_blue_shulker_box": "淡蓝色潜影盒",
  "block.minecraft.yellow_shulker_box": "黄色潜影盒",
  "block.minecraft.lime_shulker_box": "黄绿色潜影盒",
  "block.minecraft.pink_shulker_box": "粉红色潜影盒",
  "block.minecraft.gray_shulker_box": "灰色潜影盒",
  "block.minecraft.light_gray_shulker_box": "淡灰色潜影盒",
  "block.minecraft.cyan_shulker_box": "青色潜影盒",
  "block.minecraft.purple_shulker_box": "紫色潜影盒",
  "block.minecraft.blue_shulker_box": "蓝色潜影盒",
  "block.minecraft.brown_shulker_box": "棕色潜影盒",
  "block.minecraft.green_shulker_box": "绿色潜影盒",
  "block.minecraft.red_shulker_box": "红色潜影盒",
  "block.minecraft.black_shulker_box": "黑色潜影盒",
  "block.minecraft.white_glazed_terracotta": "白色带釉陶瓦",
  "block.minecraft.orange_glazed_terracotta": "橙色带釉陶瓦",
  "block.minecraft.magenta_glazed_terracotta": "品红色带釉陶瓦",
  "block.minecraft.light_blue_glazed_terracotta": "淡蓝色带釉陶瓦",
  "block.minecraft.yellow_glazed_terracotta": "黄色带釉陶瓦",
  "block.minecraft.lime_glazed_terracotta": "黄绿色带釉陶瓦",
  "block.minecraft.pink_glazed_terracotta": "粉红色带釉陶瓦",
  "block.minecraft.gray_glazed_terracotta": "灰色带釉陶瓦",
  "block.minecraft.light_gray_glazed_terracotta": "淡灰色带釉陶瓦",
  "block.minecraft.cyan_glazed_terracotta": "青色带釉陶瓦",
  "block.minecraft.purple_glazed_terracotta": "紫色带釉陶瓦",
  "block.minecraft.blue_glazed_terracotta": "蓝色带釉陶瓦",
  "block.minecraft.brown_glazed_terracotta": "棕色带釉陶瓦",
  "block.minecraft.green_glazed_terracotta": "绿色带釉陶瓦",
  "block.minecraft.red_glazed_terracotta": "红色带釉陶瓦",
  "block.minecraft.black_glazed_terracotta": "黑色带釉陶瓦",
  "block.minecraft.white_concrete": "白色混凝土",
  "block.minecraft.orange_concrete": "橙色混凝土",
  "block.minecraft.magenta_concrete": "品红色混凝土",
  "block.minecraft.light_blue_concrete": "淡蓝色混凝土",
  "block.minecraft.yellow_concrete": "黄色混凝土",
  "block.minecraft.lime_concrete": "黄绿色混凝土",
  "block.minecraft.pink_concrete": "粉红色混凝土",
  "block.minecraft.gray_concrete": "灰色混凝土",
  "block.minecraft.light_gray_concrete": "淡灰色混凝土",
  "block.minecraft.cyan_concrete": "青色混凝土",
  "block.minecraft.purple_concrete": "紫色混凝土",
  "block.minecraft.blue_concrete": "蓝色混凝土",
  "block.minecraft.brown_concrete": "棕色混凝土",
  "block.minecraft.green_concrete": "绿色混凝土",
  "block.minecraft.red_concrete": "红色混凝土",
  "block.minecraft.black_concrete": "黑色混凝土",
  "block.minecraft.white_concrete_powder": "白色混凝土粉末",
  "block.minecraft.orange_concrete_powder": "橙色混凝土粉末",
  "block.minecraft.magenta_concrete_powder": "品红色混凝土粉末",
  "block.minecraft.light_blue_concrete_powder": "淡蓝色混凝土粉末",
  "block.minecraft.yellow_concrete_powder": "黄色混凝土粉末",
  "block.minecraft.lime_concrete_powder": "黄绿色混凝土粉末",
  "block.minecraft.pink_concrete_powder": "粉红色混凝土粉末",
  "block.minecraft.gray_concrete_powder": "灰色混凝土粉末",
  "block.minecraft.light_gray_concrete_powder": "淡灰色混凝土粉末",
  "block.minecraft.cyan_concrete_powder": "青色混凝土粉末",
  "block.minecraft.purple_concrete_powder": "紫色混凝土粉末",
  "block.minecraft.blue_concrete_powder": "蓝色混凝土粉末",
  "block.minecraft.brown_concrete_powder": "棕色混凝土粉末",
  "block.minecraft.green_concrete_powder": "绿色混凝土粉末",
  "block.minecraft.red_concrete_powder": "红色混凝土粉末",
  "block.minecraft.black_concrete_powder": "黑色混凝土粉末",
  "block.minecraft.turtle_egg": "海龟蛋",
  "block.minecraft.dead_tube_coral_block": "失活的管珊瑚块",
  "block.minecraft.dead_brain_coral_block": "失活的脑纹珊瑚块",
  "block.minecraft.dead_bubble_coral_block": "失活的气泡珊瑚块",
  "block.minecraft.dead_fire_coral_block": "失活的火珊瑚块",
  "block.minecraft.dead_horn_coral_block": "失活的鹿角珊瑚块",
  "block.minecraft.tube_coral_block": "管珊瑚块",
  "block.minecraft.brain_coral_block": "脑纹珊瑚块",
  "block.minecraft.bubble_coral_block": "气泡珊瑚块",
  "block.minecraft.fire_coral_block": "火珊瑚块",
  "block.minecraft.horn_coral_block": "鹿角珊瑚块",
  "block.minecraft.tube_coral": "管珊瑚",
  "block.minecraft.brain_coral": "脑纹珊瑚",
  "block.minecraft.bubble_coral": "气泡珊瑚",
  "block.minecraft.fire_coral": "火珊瑚",
  "block.minecraft.horn_coral": "鹿角珊瑚",
  "block.minecraft.dead_brain_coral": "失活的脑纹珊瑚",
  "block.minecraft.dead_bubble_coral": "失活的气泡珊瑚",
  "block.minecraft.dead_fire_coral": "失活的火珊瑚",
  "block.minecraft.dead_horn_coral": "失活的鹿角珊瑚",
  "block.minecraft.dead_tube_coral": "失活的管珊瑚",
  "block.minecraft.tube_coral_fan": "管珊瑚扇",
  "block.minecraft.brain_coral_fan": "脑纹珊瑚扇",
  "block.minecraft.bubble_coral_fan": "气泡珊瑚扇",
  "block.minecraft.fire_coral_fan": "火珊瑚扇",
  "block.minecraft.horn_coral_fan": "鹿角珊瑚扇",
  "block.minecraft.dead_tube_coral_fan": "失活的管珊瑚扇",
  "block.minecraft.dead_brain_coral_fan": "失活的脑纹珊瑚扇",
  "block.minecraft.dead_bubble_coral_fan": "失活的气泡珊瑚扇",
  "block.minecraft.dead_fire_coral_fan": "失活的火珊瑚扇",
  "block.minecraft.dead_horn_coral_fan": "失活的鹿角珊瑚扇",
  "block.minecraft.blue_ice": "蓝冰",
  "block.minecraft.conduit": "潮涌核心",
  "block.minecraft.polished_granite_stairs": "磨制花岗岩楼梯",
  "block.minecraft.smooth_red_sandstone_stairs": "平滑红砂岩楼梯",
  "block.minecraft.mossy_stone_brick_stairs": "苔石砖楼梯",
  "block.minecraft.polished_diorite_stairs": "磨制闪长岩楼梯",
  "block.minecraft.mossy_cobblestone_stairs": "苔石楼梯",
  "block.minecraft.end_stone_brick_stairs": "末地石砖楼梯",
  "block.minecraft.stone_stairs": "石头楼梯",
  "block.minecraft.smooth_sandstone_stairs": "平滑砂岩楼梯",
  "block.minecraft.smooth_quartz_stairs": "平滑石英楼梯",
  "block.minecraft.granite_stairs": "花岗岩楼梯",
  "block.minecraft.andesite_stairs": "安山岩楼梯",
  "block.minecraft.red_nether_brick_stairs": "红色下界砖楼梯",
  "block.minecraft.polished_andesite_stairs": "磨制安山岩楼梯",
  "block.minecraft.diorite_stairs": "闪长岩楼梯",
  "block.minecraft.polished_granite_slab": "磨制花岗岩台阶",
  "block.minecraft.smooth_red_sandstone_slab": "平滑红砂岩台阶",
  "block.minecraft.mossy_stone_brick_slab": "苔石砖台阶",
  "block.minecraft.polished_diorite_slab": "磨制闪长岩台阶",
  "block.minecraft.mossy_cobblestone_slab": "苔石台阶",
  "block.minecraft.end_stone_brick_slab": "末地石砖台阶",
  "block.minecraft.smooth_sandstone_slab": "平滑砂岩台阶",
  "block.minecraft.smooth_quartz_slab": "平滑石英台阶",
  "block.minecraft.granite_slab": "花岗岩台阶",
  "block.minecraft.andesite_slab": "安山岩台阶",
  "block.minecraft.red_nether_brick_slab": "红色下界砖台阶",
  "block.minecraft.polished_andesite_slab": "磨制安山岩台阶",
  "block.minecraft.diorite_slab": "闪长岩台阶",
  "block.minecraft.scaffolding": "脚手架",
  "block.minecraft.iron_door": "铁门",
  "block.minecraft.oak_door": "橡木门",
  "block.minecraft.spruce_door": "云杉木门",
  "block.minecraft.birch_door": "白桦木门",
  "block.minecraft.jungle_door": "丛林木门",
  "block.minecraft.acacia_door": "金合欢木门",
  "block.minecraft.dark_oak_door": "深色橡木门",
  "block.minecraft.crimson_door": "绯红木门",
  "block.minecraft.warped_door": "诡异木门",
  "block.minecraft.repeater": "红石中继器",
  "block.minecraft.comparator": "红石比较器",
  "block.minecraft.structure_block": "结构方块",
  "block.minecraft.jigsaw": "拼图方块",
  "item.minecraft.turtle_helmet": "海龟壳□□戴在头上时：□+2 盔甲",
  "item.minecraft.scute": "鳞甲",
  "item.minecraft.iron_shovel": "铁锹□□在主手时：□+3.5 攻击伤害□-3 攻击速度",
  "item.minecraft.iron_pickaxe": "铁镐□□在主手时：□+3 攻击伤害□-2.8 攻击速度",
  "item.minecraft.iron_axe": "铁斧□□在主手时：□+8 攻击伤害□-3.1 攻击速度",
  "item.minecraft.flint_and_steel": "打火石",
  "item.minecraft.apple": "苹果",
  "item.minecraft.bow": "弓",
  "item.minecraft.arrow": "箭",
  "item.minecraft.coal": "煤炭",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.diamond": "钻石",
  "item.minecraft.iron_ingot": "铁锭",
  "item.minecraft.gold_ingot": "金锭",
  "item.minecraft.netherite_ingot": "下界合金锭",
  "item.minecraft.netherite_scrap": "下界合金碎片",
  "item.minecraft.iron_sword": "铁剑□□在主手时：□+5 攻击伤害□-2.4 攻击速度",
  "item.minecraft.wooden_sword": "木剑□□在主手时：□+3 攻击伤害□-2.4 攻击速度",
  "item.minecraft.wooden_shovel": "木锹□□在主手时：□+1.5 攻击伤害□-3 攻击速度",
  "item.minecraft.wooden_pickaxe": "木镐□□在主手时：□+1 攻击伤害□-2.8 攻击速度",
  "item.minecraft.wooden_axe": "木斧□□在主手时：□+6 攻击伤害□-3.2 攻击速度",
  "item.minecraft.stone_sword": "石剑□□在主手时：□+4 攻击伤害□-2.4 攻击速度",
  "item.minecraft.stone_shovel": "石锹□□在主手时：□+2.5 攻击伤害□-3 攻击速度",
  "item.minecraft.stone_pickaxe": "石镐□□在主手时：□+2 攻击伤害□-2.8 攻击速度",
  "item.minecraft.stone_axe": "石斧□□在主手时：□+8 攻击伤害□-3.2 攻击速度",
  "item.minecraft.diamond_sword": "钻石剑□□在主手时：□+6 攻击伤害□-2.4 攻击速度",
  "item.minecraft.diamond_shovel": "钻石锹□□在主手时：□+4.5 攻击伤害□-3 攻击速度",
  "item.minecraft.diamond_pickaxe": "钻石镐□□在主手时：□+4 攻击伤害□-2.8 攻击速度",
  "item.minecraft.diamond_axe": "钻石斧□□在主手时：□+8 攻击伤害□-3 攻击速度",
  "item.minecraft.stick": "木棍",
  "item.minecraft.bowl": "碗",
  "item.minecraft.mushroom_stew": "蘑菇煲",
  "item.minecraft.golden_sword": "金剑□□在主手时：□+3 攻击伤害□-2.4 攻击速度",
  "item.minecraft.golden_shovel": "金锹□□在主手时：□+1.5 攻击伤害□-3 攻击速度",
  "item.minecraft.golden_pickaxe": "金镐□□在主手时：□+1 攻击伤害□-2.8 攻击速度",
  "item.minecraft.golden_axe": "金斧□□在主手时：□+6 攻击伤害□-3 攻击速度",
  "item.minecraft.netherite_sword": "下界合金剑□□在主手时：□+7 攻击伤害□-2.4 攻击速度",
  "item.minecraft.netherite_shovel": "下界合金锹□□在主手时：□+5.5 攻击伤害□-3 攻击速度",
  "item.minecraft.netherite_pickaxe": "下界合金镐□□在主手时：□+5 攻击伤害□-2.8 攻击速度",
  "item.minecraft.netherite_axe": "下界合金斧□□在主手时：□+9 攻击伤害□-3 攻击速度",
  "item.minecraft.string": "线",
  "item.minecraft.feather": "羽毛",
  "item.minecraft.gunpowder": "火药",
  "item.minecraft.wooden_hoe": "木锄□□在主手时：□-3 攻击速度",
  "item.minecraft.stone_hoe": "石锄□□在主手时：□-2 攻击速度",
  "item.minecraft.iron_hoe": "铁锄□□在主手时：□-1 攻击速度",
  "item.minecraft.diamond_hoe": "钻石锄□□在主手时：",
  "item.minecraft.golden_hoe": "金锄□□在主手时：□-3 攻击速度",
  "item.minecraft.netherite_hoe": "下界合金锄□□在主手时：",
  "item.minecraft.wheat_seeds": "小麦种子",
  "item.minecraft.wheat": "小麦",
  "item.minecraft.bread": "面包",
  "item.minecraft.leather_helmet": "皮革帽子□□戴在头上时：□+1 盔甲",
  "item.minecraft.leather_chestplate": "皮革外套□□穿在身上时：□+3 盔甲",
  "item.minecraft.leather_leggings": "皮革裤子□□穿在腿上时：□+2 盔甲",
  "item.minecraft.leather_boots": "皮革靴子□□穿在脚上时：□+1 盔甲",
  "item.minecraft.chainmail_helmet": "锁链头盔□□戴在头上时：□+2 盔甲",
  "item.minecraft.chainmail_chestplate": "锁链胸甲□□穿在身上时：□+5 盔甲",
  "item.minecraft.chainmail_leggings": "锁链护腿□□穿在腿上时：□+4 盔甲",
  "item.minecraft.chainmail_boots": "锁链靴子□□穿在脚上时：□+1 盔甲",
  "item.minecraft.iron_helmet": "铁头盔□□戴在头上时：□+2 盔甲",
  "item.minecraft.iron_chestplate": "铁胸甲□□穿在身上时：□+6 盔甲",
  "item.minecraft.iron_leggings": "铁护腿□□穿在腿上时：□+5 盔甲",
  "item.minecraft.iron_boots": "铁靴子□□穿在脚上时：□+2 盔甲",
  "item.minecraft.diamond_helmet": "钻石头盔□□戴在头上时：□+3 盔甲□+2 盔甲韧性",
  "item.minecraft.diamond_chestplate": "钻石胸甲□□穿在身上时：□+8 盔甲□+2 盔甲韧性",
  "item.minecraft.diamond_leggings": "钻石护腿□□穿在腿上时：□+6 盔甲□+2 盔甲韧性",
  "item.minecraft.diamond_boots": "钻石靴子□□穿在脚上时：□+3 盔甲□+2 盔甲韧性",
  "item.minecraft.golden_helmet": "金头盔□□戴在头上时：□+2 盔甲",
  "item.minecraft.golden_chestplate": "金胸甲□□穿在身上时：□+5 盔甲",
  "item.minecraft.golden_leggings": "金护腿□□穿在腿上时：□+3 盔甲",
  "item.minecraft.golden_boots": "金靴子□□穿在脚上时：□+1 盔甲",
  "item.minecraft.netherite_helmet": "下界合金头盔□□戴在头上时：□+3 盔甲□+3 盔甲韧性□+1 击退抗性",
  "item.minecraft.netherite_chestplate": "下界合金胸甲□□穿在身上时：□+8 盔甲□+3 盔甲韧性□+1 击退抗性",
  "item.minecraft.netherite_leggings": "下界合金护腿□□穿在腿上时：□+6 盔甲□+3 盔甲韧性□+1 击退抗性",
  "item.minecraft.netherite_boots": "下界合金靴子□□穿在脚上时：□+3 盔甲□+3 盔甲韧性□+1 击退抗性",
  "item.minecraft.flint": "燧石",
  "item.minecraft.porkchop": "生猪排",
  "item.minecraft.cooked_porkchop": "熟猪排",
  "item.minecraft.painting": "画",
  "item.minecraft.golden_apple": "金苹果",
  "item.minecraft.enchanted_golden_apple": "附魔金苹果",
  "block.minecraft.oak_sign": "橡木告示牌",
  "block.minecraft.spruce_sign": "云杉木告示牌",
  "block.minecraft.birch_sign": "白桦木告示牌",
  "block.minecraft.jungle_sign": "丛林木告示牌",
  "block.minecraft.acacia_sign": "金合欢木告示牌",
  "block.minecraft.dark_oak_sign": "深色橡木告示牌",
  "block.minecraft.crimson_sign": "绯红木告示牌",
  "block.minecraft.warped_sign": "诡异木告示牌",
  "item.minecraft.bucket": "桶",
  "item.minecraft.water_bucket": "水桶",
  "item.minecraft.lava_bucket": "熔岩桶",
  "item.minecraft.minecart": "矿车",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.redstone": "红石粉",
  "item.minecraft.snowball": "雪球",
  "item.minecraft.oak_boat": "橡木船",
  "item.minecraft.leather": "皮革",
  "item.minecraft.milk_bucket": "奶桶",
  "item.minecraft.pufferfish_bucket": "河豚桶",
  "item.minecraft.salmon_bucket": "鲑鱼桶",
  "item.minecraft.cod_bucket": "鳕鱼桶",
  "item.minecraft.tropical_fish_bucket": "热带鱼桶",
  "item.minecraft.brick": "红砖",
  "item.minecraft.clay_ball": "黏土球",
  "block.minecraft.dried_kelp_block": "干海带块",
  "item.minecraft.paper": "纸",
  "item.minecraft.book": "书",
  "item.minecraft.slime_ball": "黏液球",
  "item.minecraft.chest_minecart": "运输矿车",
  "item.minecraft.furnace_minecart": "动力矿车",
  "item.minecraft.egg": "鸡蛋",
  "item.minecraft.compass": "指南针",
  "item.minecraft.fishing_rod": "钓鱼竿",
  "item.minecraft.clock": "时钟",
  "item.minecraft.glowstone_dust": "荧石粉",
  "item.minecraft.cod": "生鳕鱼",
  "item.minecraft.salmon": "生鲑鱼",
  "item.minecraft.tropical_fish": "热带鱼",
  "item.minecraft.pufferfish": "河豚",
  "item.minecraft.cooked_cod": "熟鳕鱼",
  "item.minecraft.cooked_salmon": "熟鲑鱼",
  "item.minecraft.ink_sac": "墨囊",
  "item.minecraft.red_dye": "红色染料",
  "item.minecraft.green_dye": "绿色染料",
  "item.minecraft.cocoa_beans": "可可豆",
  "item.minecraft.lapis_lazuli": "青金石",
  "item.minecraft.purple_dye": "紫色染料",
  "item.minecraft.cyan_dye": "青色染料",
  "item.minecraft.light_gray_dye": "淡灰色染料",
  "item.minecraft.gray_dye": "灰色染料",
  "item.minecraft.pink_dye": "粉红色染料",
  "item.minecraft.lime_dye": "黄绿色染料",
  "item.minecraft.yellow_dye": "黄色染料",
  "item.minecraft.light_blue_dye": "淡蓝色染料",
  "item.minecraft.magenta_dye": "品红色染料",
  "item.minecraft.orange_dye": "橙色染料",
  "item.minecraft.bone_meal": "骨粉",
  "item.minecraft.blue_dye": "蓝色染料",
  "item.minecraft.brown_dye": "棕色染料",
  "item.minecraft.black_dye": "黑色染料",
  "item.minecraft.white_dye": "白色染料",
  "item.minecraft.bone": "骨头",
  "item.minecraft.sugar": "糖",
  "block.minecraft.cake": "蛋糕",
  "block.minecraft.white_bed": "白色床",
  "block.minecraft.orange_bed": "橙色床",
  "block.minecraft.magenta_bed": "品红色床",
  "block.minecraft.light_blue_bed": "淡蓝色床",
  "block.minecraft.yellow_bed": "黄色床",
  "block.minecraft.lime_bed": "黄绿色床",
  "block.minecraft.pink_bed": "粉红色床",
  "block.minecraft.gray_bed": "灰色床",
  "block.minecraft.light_gray_bed": "淡灰色床",
  "block.minecraft.cyan_bed": "青色床",
  "block.minecraft.purple_bed": "紫色床",
  "block.minecraft.blue_bed": "蓝色床",
  "block.minecraft.brown_bed": "棕色床",
  "block.minecraft.green_bed": "绿色床",
  "block.minecraft.red_bed": "红色床",
  "block.minecraft.black_bed": "黑色床",
  "item.minecraft.cookie": "曲奇",
  "item.minecraft.filled_map": "地图□#0",
  "item.minecraft.shears": "剪刀",
  "item.minecraft.melon_slice": "西瓜片",
  "item.minecraft.dried_kelp": "干海带",
  "item.minecraft.pumpkin_seeds": "南瓜种子",
  "item.minecraft.melon_seeds": "西瓜种子",
  "item.minecraft.beef": "生牛肉",
  "item.minecraft.cooked_beef": "牛排",
  "item.minecraft.chicken": "生鸡肉",
  "item.minecraft.cooked_chicken": "熟鸡肉",
  "item.minecraft.rotten_flesh": "腐肉",
  "item.minecraft.ender_pearl": "末影珍珠",
  "item.minecraft.blaze_rod": "烈焰棒",
  "item.minecraft.ghast_tear": "恶魂之泪",
  "item.minecraft.gold_nugget": "金粒",
  "item.minecraft.nether_wart": "下界疣",
  "item.minecraft.potion": "不可合成的药水□无效果",
  "item.minecraft.glass_bottle": "玻璃瓶",
  "item.minecraft.spider_eye": "蜘蛛眼",
  "item.minecraft.fermented_spider_eye": "发酵蛛眼",
  "item.minecraft.blaze_powder": "烈焰粉",
  "item.minecraft.magma_cream": "岩浆膏",
  "block.minecraft.brewing_stand": "酿造台",
  "block.minecraft.cauldron": "炼药锅",
  "item.minecraft.ender_eye": "末影之眼",
  "item.minecraft.glistering_melon_slice": "闪烁的西瓜片",
  "item.minecraft.bat_spawn_egg": "蝙蝠刷怪蛋",
  "item.minecraft.bee_spawn_egg": "蜜蜂刷怪蛋",
  "item.minecraft.blaze_spawn_egg": "烈焰人刷怪蛋",
  "item.minecraft.cat_spawn_egg": "猫刷怪蛋",
  "item.minecraft.cave_spider_spawn_egg": "洞穴蜘蛛刷怪蛋",
  "item.minecraft.chicken_spawn_egg": "鸡刷怪蛋",
  "item.minecraft.cod_spawn_egg": "鳕鱼刷怪蛋",
  "item.minecraft.cow_spawn_egg": "牛刷怪蛋",
  "item.minecraft.creeper_spawn_egg": "苦力怕刷怪蛋",
  "item.minecraft.dolphin_spawn_egg": "海豚刷怪蛋",
  "item.minecraft.donkey_spawn_egg": "驴刷怪蛋",
  "item.minecraft.drowned_spawn_egg": "溺尸刷怪蛋",
  "item.minecraft.elder_guardian_spawn_egg": "远古守卫者刷怪蛋",
  "item.minecraft.enderman_spawn_egg": "末影人刷怪蛋",
  "item.minecraft.endermite_spawn_egg": "末影螨刷怪蛋",
  "item.minecraft.evoker_spawn_egg": "唤魔者刷怪蛋",
  "item.minecraft.fox_spawn_egg": "狐狸刷怪蛋",
  "item.minecraft.ghast_spawn_egg": "恶魂刷怪蛋",
  "item.minecraft.guardian_spawn_egg": "守卫者刷怪蛋",
  "item.minecraft.hoglin_spawn_egg": "疣猪兽刷怪蛋",
  "item.minecraft.horse_spawn_egg": "马刷怪蛋",
  "item.minecraft.husk_spawn_egg": "尸壳刷怪蛋",
  "item.minecraft.llama_spawn_egg": "羊驼刷怪蛋",
  "item.minecraft.magma_cube_spawn_egg": "岩浆怪刷怪蛋",
  "item.minecraft.mooshroom_spawn_egg": "哞菇刷怪蛋",
  "item.minecraft.mule_spawn_egg": "骡刷怪蛋",
  "item.minecraft.ocelot_spawn_egg": "豹猫刷怪蛋",
  "item.minecraft.panda_spawn_egg": "熊猫刷怪蛋",
  "item.minecraft.parrot_spawn_egg": "鹦鹉刷怪蛋",
  "item.minecraft.phantom_spawn_egg": "幻翼刷怪蛋",
  "item.minecraft.pig_spawn_egg": "猪刷怪蛋",
  "item.minecraft.piglin_spawn_egg": "猪灵刷怪蛋",
  "item.minecraft.pillager_spawn_egg": "掠夺者刷怪蛋",
  "item.minecraft.polar_bear_spawn_egg": "北极熊刷怪蛋",
  "item.minecraft.pufferfish_spawn_egg": "河豚刷怪蛋",
  "item.minecraft.rabbit_spawn_egg": "兔子刷怪蛋",
  "item.minecraft.ravager_spawn_egg": "劫掠兽刷怪蛋",
  "item.minecraft.salmon_spawn_egg": "鲑鱼刷怪蛋",
  "item.minecraft.sheep_spawn_egg": "绵羊刷怪蛋",
  "item.minecraft.shulker_spawn_egg": "潜影贝刷怪蛋",
  "item.minecraft.silverfish_spawn_egg": "蠹虫刷怪蛋",
  "item.minecraft.skeleton_spawn_egg": "骷髅刷怪蛋",
  "item.minecraft.skeleton_horse_spawn_egg": "骷髅马刷怪蛋",
  "item.minecraft.slime_spawn_egg": "史莱姆刷怪蛋",
  "item.minecraft.spider_spawn_egg": "蜘蛛刷怪蛋",
  "item.minecraft.squid_spawn_egg": "鱿鱼刷怪蛋",
  "item.minecraft.stray_spawn_egg": "流浪者刷怪蛋",
  "item.minecraft.strider_spawn_egg": "炽足兽刷怪蛋",
  "item.minecraft.trader_llama_spawn_egg": "行商羊驼刷怪蛋",
  "item.minecraft.tropical_fish_spawn_egg": "热带鱼刷怪蛋",
  "item.minecraft.turtle_spawn_egg": "海龟刷怪蛋",
  "item.minecraft.vex_spawn_egg": "恼鬼刷怪蛋",
  "item.minecraft.villager_spawn_egg": "村民刷怪蛋",
  "item.minecraft.vindicator_spawn_egg": "卫道士刷怪蛋",
  "item.minecraft.wandering_trader_spawn_egg": "流浪商人刷怪蛋",
  "item.minecraft.witch_spawn_egg": "女巫刷怪蛋",
  "item.minecraft.wither_skeleton_spawn_egg": "凋灵骷髅刷怪蛋",
  "item.minecraft.wolf_spawn_egg": "狼刷怪蛋",
  "item.minecraft.zoglin_spawn_egg": "僵尸疣猪兽刷怪蛋",
  "item.minecraft.zombie_spawn_egg": "僵尸刷怪蛋",
  "item.minecraft.zombie_horse_spawn_egg": "僵尸马刷怪蛋",
  "item.minecraft.zombie_villager_spawn_egg": "僵尸村民刷怪蛋",
  "item.minecraft.zombified_piglin_spawn_egg": "僵尸猪灵刷怪蛋",
  "item.minecraft.experience_bottle": "附魔之瓶",
  "item.minecraft.fire_charge": "火焰弹",
  "item.minecraft.writable_book": "书与笔",
  "item.minecraft.written_book": "成书",
  "item.minecraft.emerald": "绿宝石",
  "item.minecraft.item_frame": "物品展示框",
  "block.minecraft.flower_pot": "花盆",
  "item.minecraft.carrot": "胡萝卜",
  "item.minecraft.potato": "马铃薯",
  "item.minecraft.baked_potato": "烤马铃薯",
  "item.minecraft.poisonous_potato": "毒马铃薯",
  "item.minecraft.map": "空地图",
  "item.minecraft.golden_carrot": "金胡萝卜",
  "block.minecraft.skeleton_skull": "骷髅头颅",
  "block.minecraft.wither_skeleton_skull": "凋灵骷髅头颅",
  "block.minecraft.player_head": "玩家头颅",
  "block.minecraft.zombie_head": "僵尸的头",
  "block.minecraft.creeper_head": "苦力怕的头",
  "block.minecraft.dragon_head": "龙首",
  "item.minecraft.carrot_on_a_stick": "胡萝卜钓竿",
  "item.minecraft.warped_fungus_on_a_stick": "诡异菌钓竿",
  "item.minecraft.nether_star": "下界之星",
  "item.minecraft.pumpkin_pie": "南瓜派",
  "item.minecraft.firework_rocket": "烟花火箭",
  "item.minecraft.firework_star": "烟火之星",
  "item.minecraft.enchanted_book": "附魔书",
  "item.minecraft.nether_brick": "下界砖",
  "item.minecraft.quartz": "下界石英",
  "item.minecraft.tnt_minecart": "tnt矿车",
  "item.minecraft.hopper_minecart": "漏斗矿车",
  "item.minecraft.prismarine_shard": "海晶碎片",
  "item.minecraft.prismarine_crystals": "海晶砂粒",
  "item.minecraft.rabbit": "生兔肉",
  "item.minecraft.cooked_rabbit": "熟兔肉",
  "item.minecraft.rabbit_stew": "兔肉煲",
  "item.minecraft.rabbit_foot": "兔子脚",
  "item.minecraft.rabbit_hide": "兔子皮",
  "item.minecraft.armor_stand": "盔甲架",
  "item.minecraft.iron_horse_armor": "铁马铠",
  "item.minecraft.golden_horse_armor": "金马铠",
  "item.minecraft.diamond_horse_armor": "钻石马铠",
  "item.minecraft.leather_horse_armor": "皮革马铠",
  "item.minecraft.lead": "拴绳",
  "item.minecraft.name_tag": "命名牌",
  "item.minecraft.command_block_minecart": "命令方块矿车",
  "item.minecraft.mutton": "生羊肉",
  "item.minecraft.cooked_mutton": "熟羊肉",
  "block.minecraft.white_banner": "白色旗帜",
  "block.minecraft.orange_banner": "橙色旗帜",
  "block.minecraft.magenta_banner": "品红色旗帜",
  "block.minecraft.light_blue_banner": "淡蓝色旗帜",
  "block.minecraft.yellow_banner": "黄色旗帜",
  "block.minecraft.lime_banner": "黄绿色旗帜",
  "block.minecraft.pink_banner": "粉红色旗帜",
  "block.minecraft.gray_banner": "灰色旗帜",
  "block.minecraft.light_gray_banner": "淡灰色旗帜",
  "block.minecraft.cyan_banner": "青色旗帜",
  "block.minecraft.purple_banner": "紫色旗帜",
  "block.minecraft.blue_banner": "蓝色旗帜",
  "block.minecraft.brown_banner": "棕色旗帜",
  "block.minecraft.green_banner": "绿色旗帜",
  "block.minecraft.red_banner": "红色旗帜",
  "block.minecraft.black_banner": "黑色旗帜",
  "item.minecraft.end_crystal": "末影水晶",
  "item.minecraft.chorus_fruit": "紫颂果",
  "item.minecraft.popped_chorus_fruit": "爆裂紫颂果",
  "item.minecraft.beetroot": "甜菜根",
  "item.minecraft.beetroot_seeds": "甜菜种子",
  "item.minecraft.beetroot_soup": "甜菜汤",
  "item.minecraft.dragon_breath": "龙息",
  "item.minecraft.splash_potion": "不可合成的喷溅型药水□无效果",
  "item.minecraft.spectral_arrow": "光灵箭",
  "item.minecraft.tipped_arrow": "不可合成的药箭□无效果",
  "item.minecraft.lingering_potion": "不可合成的滞留型药水□无效果",
  "item.minecraft.shield": "盾牌",
  "item.minecraft.elytra": "鞘翅",
  "item.minecraft.spruce_boat": "云杉木船",
  "item.minecraft.birch_boat": "白桦木船",
  "item.minecraft.jungle_boat": "丛林木船",
  "item.minecraft.acacia_boat": "金合欢木船",
  "item.minecraft.dark_oak_boat": "深色橡木船",
  "item.minecraft.totem_of_undying": "不死图腾",
  "item.minecraft.shulker_shell": "潜影壳",
  "item.minecraft.iron_nugget": "铁粒",
  "item.minecraft.knowledge_book": "知识之书",
  "item.minecraft.debug_stick": "调试棒",
  "item.minecraft.music_disc_13": "音乐唱片□c418 - 13",
  "item.minecraft.music_disc_cat": "音乐唱片□c418 - cat",
  "item.minecraft.music_disc_blocks": "音乐唱片□c418 - blocks",
  "item.minecraft.music_disc_chirp": "音乐唱片□c418 - chirp",
  "item.minecraft.music_disc_far": "音乐唱片□c418 - far",
  "item.minecraft.music_disc_mall": "音乐唱片□c418 - mall",
  "item.minecraft.music_disc_mellohi": "音乐唱片□c418 - mellohi",
  "item.minecraft.music_disc_stal": "音乐唱片□c418 - stal",
  "item.minecraft.music_disc_strad": "音乐唱片□c418 - strad",
  "item.minecraft.music_disc_ward": "音乐唱片□c418 - ward",
  "item.minecraft.music_disc_11": "音乐唱片□c418 - 11",
  "item.minecraft.music_disc_wait": "音乐唱片□c418 - wait",
  "item.minecraft.music_disc_pigstep": "音乐唱片□lena raine - pigstep",
  "item.minecraft.trident": "三叉戟□□在主手时：□+8 攻击伤害□-2.9 攻击速度",
  "item.minecraft.phantom_membrane": "幻翼膜",
  "item.minecraft.nautilus_shell": "鹦鹉螺壳",
  "item.minecraft.heart_of_the_sea": "海洋之心",
  "item.minecraft.crossbow": "弩",
  "item.minecraft.suspicious_stew": "迷之炖菜",
  "block.minecraft.loom": "织布机",
  "item.minecraft.flower_banner_pattern": "旗帜图案□花朵盾徽",
  "item.minecraft.creeper_banner_pattern": "旗帜图案□苦力怕盾徽",
  "item.minecraft.skull_banner_pattern": "旗帜图案□头颅盾徽",
  "item.minecraft.mojang_banner_pattern": "旗帜图案□mojang徽标",
  "item.minecraft.globe_banner_pattern": "旗帜图案□地球",
  "item.minecraft.piglin_banner_pattern": "旗帜图案□猪鼻",
  "block.minecraft.composter": "堆肥桶",
  "block.minecraft.barrel": "木桶",
  "block.minecraft.smoker": "烟熏炉",
  "block.minecraft.blast_furnace": "高炉",
  "block.minecraft.cartography_table": "制图台",
  "block.minecraft.fletching_table": "制箭台",
  "block.minecraft.grindstone": "砂轮",
  "block.minecraft.lectern": "讲台",
  "block.minecraft.smithing_table": "锻造台",
  "block.minecraft.stonecutter": "切石机",
  "block.minecraft.bell": "钟",
  "block.minecraft.lantern": "灯笼",
  "block.minecraft.soul_lantern": "灵魂灯笼",
  "item.minecraft.sweet_berries": "甜浆果",
  "block.minecraft.campfire": "营火",
  "block.minecraft.soul_campfire": "灵魂营火",
  "block.minecraft.shroomlight": "菌光体",
  "item.minecraft.honeycomb": "蜜脾",
  "block.minecraft.bee_nest": "蜂巢",
  "block.minecraft.beehive": "蜂箱",
  "item.minecraft.honey_bottle": "蜂蜜瓶",
  "block.minecraft.honey_block": "蜂蜜块",
  "block.minecraft.honeycomb_block": "蜜脾块",
  "block.minecraft.lodestone": "磁石",
  "block.minecraft.netherite_block": "下界合金块",
  "block.minecraft.ancient_debris": "远古残骸",
  "block.minecraft.target": "标靶",
  "block.minecraft.crying_obsidian": "哭泣的黑曜石",
  "block.minecraft.blackstone": "黑石",
  "block.minecraft.blackstone_slab": "黑石台阶",
  "block.minecraft.blackstone_stairs": "黑石楼梯",
  "block.minecraft.gilded_blackstone": "镶金黑石",
  "block.minecraft.polished_blackstone": "磨制黑石",
  "block.minecraft.polished_blackstone_slab": "磨制黑石台阶",
  "block.minecraft.polished_blackstone_stairs": "磨制黑石楼梯",
  "block.minecraft.chiseled_polished_blackstone": "錾制磨制黑石",
  "block.minecraft.polished_blackstone_bricks": "磨制黑石砖",
  "block.minecraft.polished_blackstone_brick_slab": "磨制黑石砖台阶",
  "block.minecraft.polished_blackstone_brick_stairs": "磨制黑石砖楼梯",
  "block.minecraft.cracked_polished_blackstone_bricks": "裂纹磨制黑石砖",
  "block.minecraft.respawn_anchor": "重生锚",
}
export const zh_cn = items; 
